import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import * as Chart from 'chart.js';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: '',
  template: '',
})
export class RegionWiseChartHandler {
  chart: Chart;
  @Output() closeChart = new EventEmitter<string>();
  pieColorArray = [];
  @Input() usedFor;

  // Region chart
  regionChartData;
  multiLevelLabelPlugin;
  regionChartOptions;

  regionRawData;
  public agentRegionWiseGraph: any;
  public selectedRegion: string = '';
  agentsData;
  regionChart: boolean;
  public channelChartData;
  public regionArr = [];
  public regionChannelArr;

  // Channel Chart
  channelChartConfigs;
  preparedCharts = [];
  public agentChannelWiseGraph: any;
  public selectedChannel: string = '';
  channelChart: boolean;
  public channelArr;

  frequencyArr = [
    this.settingService.getLabelValue('monthly'),
    this.settingService.getLabelValue('quarterly'),
    this.settingService.getLabelValue('yearly'),
  ];
  regionFrequency = this.settingService.getLabelValue('yearly');
  channelFrequency = this.settingService.getLabelValue('quarterly');
  selectedCalculationYears = [];

  chartConfigs: { channel: string; year: string }[] = [];
  createdChartIds = new Set<string>();

  public calculationyears;
  private originalRectangleDraw;
  private userLoginData;

  constructor(public service: DashboardService, public settingService: SettingService) {
    this.regionChart = true;
    const dateStr = this.service.getDateFormatted(this.settingService.getSessionStorageValue('BatchDate'));
    const year = parseInt(dateStr.split('/')[2], 10);
    this.calculationyears = [String(year), String(year + 1)];
    this.originalRectangleDraw = Chart.elements.Rectangle.prototype.draw;

    if (sessionStorage.getItem('userLoginData') != undefined) {
      this.userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    }
  }

  ngOnInit() {
    this.loadBarChartDetails();
  }

  public loadBarChartDetails() {
    this.pieColorArray = this.service.getColor();
    setTimeout(() => {
      this.regionWiseChartBrowser();
    }, 10);
  }

  onChannelWiseChartClick() {
    $('#agentRegionWiseStatusModal').hide();
    this.channelChart = true;
    this.regionChart = false;
    this.selectedChannel = '';
    setTimeout(() => {
      this.channelWiseDoughnutChartBrowser();
    }, 10);
  }

  onRegionWiseChartBrowser() {
    $('#agentRegionWiseStatusModal').hide();
    this.channelChart = false;
    this.regionChart = true;
    this.selectedRegion = '';
    this.selectedChannel = '';
    setTimeout(() => {
      this.regionWiseChartBrowser();
    }, 10);
  }

  /* Region Chart Code Starts Here */
  regionWiseChartBrowser(selectedRegionChannel?, regionFrequency?, selectedRegion?, regionCalculationYears?) {
    this.channelChart = false;
    this.regionChart = true;
    this.regionFrequency = regionFrequency || 'YEARLY';

    let apiObservable = this.getApiObservable(regionCalculationYears);

    if (!apiObservable) {
      console.error('Invalid chart type provided.');
      return;
    }

    apiObservable.subscribe(
      (res) => {
        const rawData = this.service.extractApiData(res);
        if (!rawData) return;

        this.processApiResponse(rawData, selectedRegionChannel, selectedRegion, regionCalculationYears);
      },
      (error) => {
        console.log('Error:', error);
        this.service.handleError(error);
      }
    );
  }

  private getApiObservable(regionCalculationYears?) {
    if (this.usedFor === 'newBusiness' || this.usedFor === 'brokerNewBusiness') {
      return this.service.getNewBusinessData(
        ['channelcd', 'regioncd'],
        this.regionFrequency,
        regionCalculationYears
      );
    } else if (this.usedFor === 'performance' || this.usedFor === 'brokerPerformance') {
      return this.service.getPerformanceData(
        ['channelcd', 'regioncd'],
        this.regionFrequency,
        regionCalculationYears
      );
    } else if (this.usedFor === 'incomeVsExpense') {
      return this.service.getIncomeExpenseData(['regioncd'], this.regionFrequency, regionCalculationYears);
    }
    return null;
  }

  private processApiResponse(rawData, selectedRegionChannel, selectedRegion, regionCalculationYears) {
    this.regionRawData = rawData;

    const channelList = Object.keys(this.regionRawData);
    this.regionChannelArr = ['All', ...channelList];

    if (this.usedFor === 'performance') {
      selectedRegionChannel = channelList[0];
    }

    // const selectedChannels = this.getSelectedChannels(selectedRegionChannel, channelList);
    const selectedChannels = this.service.getChannelsToProcess(selectedRegionChannel, channelList);

    const chartColors = this.service.regionColors();

    const { regionList, quarterList } = this.extractRegionsAndQuarters(rawData, selectedChannels);

    if (!regionCalculationYears || regionCalculationYears.length === 0) {
      regionCalculationYears = this.extractYears(rawData);
    }

    this.regionArr = ['All', ...regionList];

    const filteredRegions = this.getFilteredRegions(selectedRegion, regionList);

    const { labels, xMeta, tooltipMeta } = this.buildLabels(regionCalculationYears, selectedChannels, quarterList);

    const datasets = this.buildDatasets(filteredRegions, xMeta, rawData, chartColors, tooltipMeta);

    const years = this.buildYearSections(xMeta);

    this.multiLevelLabelPlugin = this.createMultiLevelLabelPlugin(
      selectedChannels,
      years,
      tooltipMeta,
      quarterList
    );

    this.regionChartData = { labels, datasets };

    this.regionChartOptions = this.buildChartOptions(tooltipMeta);
  }

  private extractRegionsAndQuarters(rawData, selectedChannels) {
    const allRegions = new Set<string>();
    const allQuarters = new Set<string>();

    selectedChannels.forEach((channel) => {
      const channelData = rawData[channel];
      if (channelData) {
        Object.keys(channelData).forEach((region) => {
          allRegions.add(region);
          const years = Object.keys(channelData[region] || {});
          years.forEach((year) => {
            const periodData = channelData[region][year]?.data || {};
            Object.keys(periodData).forEach((q) => allQuarters.add(q));
          });
        });
      }
    });

    return { regionList: Array.from(allRegions), quarterList: Array.from(allQuarters).sort() };
  }

  private extractYears(rawData) {
    const yearSet = new Set<string>();

    Object.values(rawData).forEach((channelData: any) => {
      Object.values(channelData).forEach((regionData: any) => {
        Object.keys(regionData).forEach((year: string) => {
          yearSet.add(year);
        });
      });
    });

    return Array.from(yearSet).sort();
  }

  private getFilteredRegions(selectedRegion, regionList) {
    if (!selectedRegion || selectedRegion.length === 0 || selectedRegion.includes('All')) {
      return regionList;
    }
    return selectedRegion.filter((r) => regionList.includes(r));
  }

  private buildLabels(regionCalculationYears, selectedChannels, quarterList) {
    const labels: string[] = [];
    const tooltipMeta: { [index: number]: { year: string; period: string; channel: string } } = {};
    const xMeta: { year: string; period: string; channel: string }[] = [];

    regionCalculationYears.forEach((year) => {
      selectedChannels.forEach((channel) => {
        quarterList.forEach((quarter) => {
          labels.push(`${quarter} - ${year}`);
          xMeta.push({ year, period: quarter, channel });
        });
      });
    });

    return { labels, xMeta, tooltipMeta };
  }

  private buildDatasets(filteredRegions, xMeta, rawData, chartColors, tooltipMeta) {
    return filteredRegions.map((region, rIndex) => {
      const data: number[] = [];

      xMeta.forEach((entry, idx) => {
        const val = rawData?.[entry.channel]?.[region]?.[entry.year]?.data?.[entry.period] ?? 0;
        data.push(val);
        tooltipMeta[idx] = {
          year: entry.year,
          period: entry.period,
          channel: entry.channel,
        };
      });

      return {
        label: region,
        data,
        backgroundColor: chartColors[rIndex % chartColors.length],
        barPercentage: data.length > 4 ? 0.9 : 0.6,
        categoryPercentage: data.length > 4 ? 0.8 : 0.5,
      };
    });
  }

  private buildYearSections(xMeta) {
    const years: any[] = [];
    let currentYear = '';
    let from = 0;

    xMeta.forEach((entry, idx) => {
      if (entry.year !== currentYear) {
        if (currentYear) {
          years.push({ label: currentYear, from, to: idx - 1 });
        }
        currentYear = entry.year;
        from = idx;
      }
    });
    years.push({ label: currentYear, from, to: xMeta.length - 1 });

    return years;
  }

  private createMultiLevelLabelPlugin(selectedChannels, years, tooltipMeta, quarterList) {
    const frequency = this.regionFrequency;
    const quartersPerChannel =
      frequency === 'MONTHLY' ? 12 : frequency === 'QUARTERLY' ? 4 : frequency === 'YEARLY' ? 1 : 4;
    const isTrue = this.usedFor !== 'performance';

    return {
      beforeDraw(chart: any) {
        const ctx = chart.chart.ctx;
        const yAxis = chart.scales['y-axis-0'];
        const chartArea = chart.chartArea;
        const labels = chart?.data?.labels || [];

        if (!yAxis || !labels.length || !selectedChannels?.length) return;

        const channelsCount = selectedChannels.length;
        const blockSize = channelsCount * quartersPerChannel;
        const yearCount = Math.floor(labels.length / blockSize);

        ctx.save();
        ctx.font = '12px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        if (frequency != 'YEARLY')
          yAxis.ticks.forEach((value: string, index: number) => {
            const y = yAxis.getPixelForTick(index);
            const x = chartArea.left - 10;
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(Math.PI / 2);
            ctx.fillText(value, 0, 0);
            ctx.restore();
          });

        for (let i = 0; i < yearCount; i++) {
          const baseIdx = i * blockSize;
          if (baseIdx >= labels.length) continue;

          const yearLabel = labels[baseIdx]?.split('-')?.[1]?.trim() || '';
          const startY = yAxis.getPixelForTick(baseIdx);
          const endY = yAxis.getPixelForTick(baseIdx + blockSize - 1);
          const yearCenterY = (startY + endY) / 2;

          ctx.save();
          ctx.translate(chartArea.right + 10, yearCenterY);
          ctx.rotate(Math.PI / 2);
          ctx.fillText(yearLabel, 0, 0);
          ctx.restore();

          selectedChannels.forEach((channel, cIdx) => {
            const fromIdx = baseIdx + cIdx * quartersPerChannel;
            const toIdx = fromIdx + quartersPerChannel - 1;
            if (toIdx >= labels.length) return;
            const channelCenterY = (yAxis.getPixelForTick(fromIdx) + yAxis.getPixelForTick(toIdx)) / 2;
            ctx.save();
            ctx.translate(chartArea.left - 40, channelCenterY);
            ctx.rotate(Math.PI / 2);
            if (isTrue) ctx.fillText(channel, 0, 0);
            ctx.restore();
          });

          if (i < yearCount - 1) {
            const separatorY =
              (yAxis.getPixelForTick(baseIdx + blockSize - 1) + yAxis.getPixelForTick(baseIdx + blockSize)) / 2;
            const pixelRatio = chart.chart.currentDevicePixelRatio || 1;
            const adjustedSeparatorY = Math.round(separatorY * pixelRatio) / pixelRatio + 0.5;
            ctx.beginPath();
            ctx.setLineDash([6, 3]);
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#aaa';
            ctx.moveTo(chartArea.left, adjustedSeparatorY);
            ctx.lineTo(chartArea.right, adjustedSeparatorY);
            ctx.stroke();
            ctx.setLineDash([]);
          }

          for (let c = 1; c < channelsCount; c++) {
            const channelSepIdx = baseIdx + c * quartersPerChannel - 1;
            if (channelSepIdx >= labels.length) continue;
            const channelSeparatorY =
              (yAxis.getPixelForTick(channelSepIdx) + yAxis.getPixelForTick(channelSepIdx + 1)) / 2;
            const pixelRatio = chart.chart.currentDevicePixelRatio || 1;
            const adjustedChannelSeparatorY = Math.round(channelSeparatorY * pixelRatio) / pixelRatio + 0.5;

            ctx.beginPath();
            ctx.setLineDash([4, 2]);
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#ccc';
            ctx.moveTo(chartArea.left, adjustedChannelSeparatorY);
            ctx.lineTo(chartArea.right, adjustedChannelSeparatorY);
            ctx.stroke();
            ctx.setLineDash([]);
          }
        }
        ctx.restore();
      },
    };
  }

  /* Filter Code For Region/Channel Starts Here */
  onFilterData() {
    $('#agentRegionWiseStatusModal').toggle();
  }

  closeRegionModal() {
    this.selectedChannel = '';
    this.selectedRegion = '';
    $('#agentRegionWiseStatusModal').hide();
  }

  filterRegion() {
    $('#agentRegionWiseStatusModal').hide();
    this.regionChart = false;
    setTimeout(() => {
      if (this.agentRegionWiseGraph) {
        this.agentRegionWiseGraph.destroy();
        this.agentRegionWiseGraph = null;
      }
      this.regionChart = true;
      setTimeout(() => {
        this.regionWiseChartBrowser(
          this.selectedChannel,
          this.regionFrequency,
          this.selectedRegion,
          this.selectedCalculationYears
        );
      }, 10);
    }, 10);
  }

  closeChannelModal() {
    this.selectedChannel = '';
    $('#agentRegionWiseStatusModal').hide();
  }

  filterChannel() {
    $('#agentRegionWiseStatusModal').hide();
    this.channelChart = false;

    setTimeout(() => {
      if (this.agentChannelWiseGraph) {
        this.agentChannelWiseGraph.destroy();
        this.agentChannelWiseGraph = null;
      }

      this.channelChart = true;
      setTimeout(() => {
        this.channelWiseDoughnutChartBrowser(
          this.selectedChannel,
          this.channelFrequency,
          this.selectedCalculationYears
        );
      }, 10);
    }, 10);
  }

  onDateRangeChannelChange(event: any) {
    let selectedYears: string[] = this.service.onDateRangeChange(event);
    if (!selectedYears || selectedYears.length === 0) return;

    const numericYears: number[] = selectedYears.map((y) => +y);
    this.channelWiseDoughnutChartBrowser(this.selectedChannel, this.channelFrequency, numericYears);
  }

  onDateRangeRegionChange(event: any) {
    let selectedYears: string[] = this.service.onDateRangeChange(event);
    if (!selectedYears || selectedYears.length === 0) return;

    const numericYears: number[] = selectedYears.map((y) => +y);

    this.regionWiseChartBrowser(this.selectedChannel, this.regionFrequency, this.selectedRegion, numericYears);
  }

  /* Filter Code For Region/Channel Ends Here */

  /* Channel Chart Code Starts Here */

  channelWiseDoughnutChartBrowser(
    selectedChannel?: string | string[],
    frequency?: string,
    calculationyears?: number[]
  ) {
    this.channelFrequency = frequency || this.channelFrequency || 'QUARTERLY';

    this.service.getNewBusinessData(['channelcd'], this.channelFrequency, calculationyears).subscribe(
      (res) => {
        const rawData = this.service.extractApiData(res);
        const availableChannels = Object.keys(rawData);
        this.channelArr = ['All', ...availableChannels];
        this.channelChartConfigs = [];
        const channelsToProcess = this.service.getChannelsToProcess(selectedChannel, availableChannels);
        const colorSet = this.service.getColor();

        const preparedCharts = this.prepareCharts(rawData, channelsToProcess, calculationyears, colorSet);

        this.channelChartConfigs = preparedCharts;
      },
      (error) => {
        console.error('Error:', error);
        this.service.handleError(error);
      }
    );
  }

  private prepareCharts(
    rawData: any,
    channels: string[],
    calculationyears: number[] | undefined,
    colorSet: string[]
  ) {
    const charts = [];

    channels.forEach((channel) => {
      const channelData = rawData[channel];
      if (!channelData) return;

      const allYears = this.getFilteredYears(channelData, calculationyears);

      allYears.forEach((year) => {
        const yearData = channelData[year]?.data || channelData[year];
        console.log('yearData', yearData);

        if (!yearData) return;

        if (!this.hasValidData(yearData)) return;

        const chartConfig = this.buildChartConfig(channel, year, yearData, colorSet);
        charts.push(chartConfig);
      });
    });

    return charts;
  }

  private getFilteredYears(channelData: any, calculationyears?: number[]): string[] {
    return Object.keys(channelData)
      .filter((year) => !calculationyears || calculationyears.length === 0 || calculationyears.includes(+year))
      .sort((a, b) => +b - +a)
      .slice(0, 2);
  }

  private hasValidData(yearData: any): boolean {
    console.log(
      '=======>',
      Object.values(yearData)
        .map(Number)
        .some((val) => val > 0)
    );

    return Object.values(yearData)
      .map(Number)
      .some((val) => val > 0);
  }

  private buildChartConfig(channel: string, year: string, yearData: any, colorSet: string[]) {
    const keys = Object.keys(yearData);
    const labels = keys.map((key) => `${key} ${year}`);
    const dataValues = keys.map((key) => yearData[key]);
    const colors = keys.map((_, i) => colorSet[i % colorSet.length]);

    return {
      chartTitle: `${channel} - ${year}`,
      chartData: {
        labels,
        datasets: [
          {
            label: channel,
            data: dataValues,
            backgroundColor: colors,
          },
        ],
      },
      chartOptions: this.buildChartOptions(),
      isMultiSeries: false,
    };
  }

  private buildChartOptions(tooltipMeta?) {
    const commonFontSettings = {
      fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
      fontColor: '#000000',
    };

    if (this.regionChart && tooltipMeta != undefined) {
      return {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        layout: {
          padding: { left: 40, right: 30 },
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                display: false,
                autoSkip: false,
                callback: function (value) {
                  return value.split('-')[0];
                },
                ...commonFontSettings,
              },
              scaleLabel: {
                display: false,
                ...commonFontSettings,
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                callback: function (value) {
                  return value.toLocaleString();
                },
                ...commonFontSettings,
              },
              scaleLabel: {
                display: false,
                ...commonFontSettings,
              },
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom',
          align: 'center',
          labels: {
            boxWidth: 12,
            fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
            padding: this.settingService.isMobileViewRendered() ? 30 : 30,
            ...commonFontSettings,
          },
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          bodyFontFamily: commonFontSettings.fontFamily,
          callbacks: {
            title: (tooltipItems) => {
              const idx = tooltipItems[0].index;
              const meta = tooltipMeta[idx];
              return `${meta.channel} - ${meta.period}, ${meta.year}`;
            },
            label: (tooltipItem, data) => {
              const datasetIndex = tooltipItem.datasetIndex;
              const dataIndex = tooltipItem.index;
              const value = Number(data.datasets[datasetIndex].data[dataIndex]);
              let total = 0;
              for (let i = 0; i < data.datasets.length; i++) {
                total += Number(data.datasets[i].data[dataIndex]);
              }
              const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : 0;
              const datasetLabel = data.datasets[datasetIndex]?.label || '';
              return `${datasetLabel}: ${value.toLocaleString()} (${percentage}%)`;
            },
          },
        },
        plugins: {
          datalabels: false,
        },
      };
    }

    if (this.channelChart) {
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'nearest',
          intersect: true,
          bodyFontFamily: commonFontSettings.fontFamily,
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const label = dataset?.label || '';
              const rawValue = dataset?.data?.[tooltipItem.index];
              const value = typeof rawValue === 'number' ? rawValue : parseFloat(rawValue || '0');
              const formattedValue = value.toLocaleString();
              let total: number = 0;
              for (let i = 0; i < data.datasets[0].data.length; i++) {
                total = total + data.datasets[0].data[i];
              }
              const percentage = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / total) * 100;
              const formattedPercentage = percentage % 1 === 0 ? percentage.toFixed(0) : percentage.toFixed(2);
              return `${label}: ${formattedValue} (${formattedPercentage}%)`;
            },
          },
        },
        plugins: {
          datalabels: false,
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            ...commonFontSettings,
          },
        },
      };
    }
  }

  // Close the Chart on click of the close button
  onCloseClick() {
    this.closeChart.emit(this.chart);
  }

  get frequencyValue(): string {
    return this.regionChart ? this.regionFrequency : this.channelFrequency;
  }

  set frequencyValue(value: string) {
    if (this.regionChart) {
      this.regionFrequency = value;
    } else {
      this.channelFrequency = value;
    }
  }

  clearData() {
    // Reset filter selections
    this.selectedRegion = '';
    this.selectedChannel = '';
    this.selectedCalculationYears = [];

    // Reset frequency based on active chart
    if (this.regionChart) {
      this.regionFrequency = this.settingService.getLabelValue('yearly');
    } else if (this.channelChart) {
      this.channelFrequency = this.settingService.getLabelValue('quarterly');
    }

    // Clear date range picker (if exists)
    const datePicker: any = document.getElementById('mydaterange-picker12');
    if (datePicker) {
      datePicker.value = '';
    }

    // Hide modal before rerender
    $('#agentRegionWiseStatusModal').hide();

    // Destroy and rerender only the active chart
    setTimeout(() => {
      if (this.regionChart && this.agentRegionWiseGraph) {
        this.agentRegionWiseGraph.destroy();
        this.agentRegionWiseGraph = null;
      } else if (this.channelChart && this.agentChannelWiseGraph) {
        this.agentChannelWiseGraph.destroy();
        this.agentChannelWiseGraph = null;
      }

      // Re-render only the currently active chart
      if (this.regionChart) {
        this.regionWiseChartBrowser();
      } else if (this.channelChart) {
        this.channelWiseDoughnutChartBrowser();
      }
    }, 10);
  }

  ngOnDestroy() {
    this.service.clear();
    Chart.elements.Rectangle.prototype.draw = this.originalRectangleDraw;
  }
}
